<template lang="html">
  <div class="editor dialog">
    <div class="stage">
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="grid">
        <defs>
          <pattern id="pix10" width="10" height="10" patternUnits="userSpaceOnUse" :x="viewpoint.x" :y="viewpoint.y" >
            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(120, 120, 120, 0.1)" stroke-width="1"/>
          </pattern>
          <pattern id="area80" width="80" height="80" patternUnits="userSpaceOnUse" :x="viewpoint.x" :y="viewpoint.y" >
            <path d="M 80 0 L 0 0 0 80" fill="none" stroke="rgba(120, 120, 120, 0.15)" stroke-width="2"/>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#pix10)" />
        <rect width="100%" height="100%" fill="url(#area80)" />
      </svg>
      <svg ref="paths" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="paths"></svg>
      <svg ref="tempPath" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" class="paths"></svg>
      <div ref="nodes" class="nodes noselect" @mousedown="move" @touchstart="move" @mousemove="move" @touchmove="move">
        <div v-for="node in dialogTree" :key="node.uuid" :data-uuid="node.uuid" class="node-box" :class="{'selected': node === selectedNode}" :style="{transform: `translate(${node.position.x + viewpoint.x}px, ${node.position.y + viewpoint.y}px)`}">
          <div class="label node-header node-move" :style="{ backgroundColor: getColor(node.type) }">
            <input type="text" v-model="node.name" placeholder="name" class="form-input" />
            <!-- <span style="width: 100%;">Dialog</span> -->
            <button type="button" class="btn-flat btn-icon" @click="toggleAttributes(node)"><i class="icon-tool"></i> <span v-if="node.attributes.length" class="badge">{{node.attributes.length}}</span></button>
            <button type="button" class="btn-flat btn-icon" :class="{ 'selected': fileData.data.edit.init === node.uuid }" @click="toggleInit(node)"><i :class="{ 'icon-star_border': fileData.data.edit.init !== node.uuid, 'icon-star': fileData.data.edit.init === node.uuid }"></i></button>
          </div>
          <MessageNode v-if="isTypeEquals(node, 'dialog')" :node="node" />
          <SplitNode v-if="isTypeEquals(node, 'split')" :node="node" />
          <ExecuteNode v-if="isTypeEquals(node, 'execute')" :node="node" />
          <Attributes v-if="attributesOpen.includes(node.uuid)" :node="node" />
        </div>
      </div>
    </div>
    <div class="toolbar float-panel">
      <button type="button" class="btn-icon" title="New dialog" @click="addNode('dialog')"><i class="icon-chat_bubble"></i></button>
      <button type="button" class="btn-icon" title="New split" @click="addNode('split')"><i class="icon-device_hub"></i></button>
      <button type="button" class="btn-icon" title="New execute" @click="addNode('execute')"><i class="icon-code"></i></button>
      <div v-if="selectedNode" class="submenu">
        <button type="button" class="btn-icon" title="Duplicate" @click="duplicateNode()"><i class="icon-copy"></i></button>
        <button type="button" class="btn-icon" title="Delete" @click="removeNode()"><i class="icon-delete"></i></button>
      </div>
    </div>
  </div>
</template>

<script>
import MessageNode from '@/assets/components/dialog/MessageNode.vue'
import SplitNode from '@/assets/components/dialog/SplitNode.vue'
import ExecuteNode from '@/assets/components/dialog/ExecuteNode.vue'
import Attributes from '@/assets/components/dialog/Attributes.vue'
const Util = window.Util;
const UtilEditor = window.UtilEditor;

export default {
  props: ['fileData'],
  components: {
    MessageNode,
    SplitNode,
    ExecuteNode,
    Attributes
  },
  data() {
    return {
      dialogTree: this.fileData.data.edit.nodes,
      holdNode: null,
      selectedNode: null,
      linkChoice: null,
      moveBinded: null,
      viewpoint: { x: 0, y: 0 },
      attributesOpen: []
    };
  },
  methods: {
    addNode(type) {
      const node = {
        uuid: Util.uuidv4(),
        name: '',
        position: {
          x: Math.trunc(-this.viewpoint.x),
          y: Math.trunc(-this.viewpoint.y)
        },
        attributes: []
      };
      switch (type) {
        case 'dialog':
          Object.assign(node, {
            type: 'dialog',
            texts: [''],
            asset: '',
            choices: []
          });
          break;
        case 'split':
          Object.assign(node, {
            type: 'split',
            subtype: 'random',
            choices: []
          });
          break;
        case 'execute':
          Object.assign(node, {
            type: 'execute',
            code: '',
            to: null
          });
          break;
      }
      this.dialogTree.push(node);
    },
    isTypeEquals(node, type) {
      return (node.type || 'dialog') === type;
    },
    getColor(type) {
      const colors = {
        dialog: '#265073',
        split: '#602035',
        execute: '#602035'
      };
      return colors[type || 'dialog'];
    },
    duplicateNode() {
      if (!this.selectedNode) return;
      const clone = Util.jsonClone(this.selectedNode);
      clone.uuid = Util.uuidv4();
      clone.position.x += 10;
      clone.position.y += 10;
      clone.choices.forEach((choice) => {
        choice.to = null;
      });
      this.dialogTree.push(clone);
      this.selectedNode = clone;
    },
    removeNode() {
      if (!this.selectedNode) return;
      this.dialogTree.splice(this.dialogTree.indexOf(this.selectedNode), 1);
      this.selectedNode = null;
    },
    toggleInit(node) {
      if (this.fileData.data.edit.init === node.uuid) {
        this.fileData.data.edit.init = null;
      } else {
        this.fileData.data.edit.init = node.uuid;
      }
    },
    toggleAttributes(node) {
      const index = this.attributesOpen.indexOf(node.uuid);
      if (index === -1) {
        this.attributesOpen.push(node.uuid);
      } else {
        this.attributesOpen.splice(index, 1);
      }
    },
    move(event) {
      if (['mouseup', 'touchend'].includes(event.type)) {
        this.holdNode = null;
      } else if (this.holdNode) {
        const movePosition = Util.eventPosition(event);
        if (!movePosition) return;
        movePosition.x -= this.holdNode.offset.x;
        movePosition.y -= this.holdNode.offset.y;
        if (this.holdNode.isViewpoint) {
          this.viewpoint = movePosition;
          this.$nextTick(this.renderPaths);
        } else {
          this.holdNode.node.position = movePosition;
        }
      } else if (['mousedown', 'touchstart'].includes(event.type)) {
        const selectedEl = event.target.closest('.node-box');
        if (selectedEl) {
          const uuid = selectedEl.getAttribute('data-uuid');
          const rect = selectedEl.getBoundingClientRect();
          this.selectedNode = this.dialogTree.find(a => a.uuid === uuid);
          if (event.target.closest('.node-move')) {
            const client = event.type === 'touchstart' ? event.touches[0] : event;
            this.holdNode = {
              node: this.selectedNode,
              offset: {
                x: Math.trunc(client.clientX - rect.x + this.viewpoint.x),
                y: Math.trunc(client.clientY - rect.y + this.viewpoint.y)
              }
            };
          }
        } else {
          this.selectedNode = null;
          const movePosition = Util.eventPosition(event);
          if (!movePosition) return;
          this.holdNode = {
            isViewpoint: true,
            offset: {
              x: Math.trunc(movePosition.x - this.viewpoint.x),
              y: Math.trunc(movePosition.y - this.viewpoint.y)
            }
          };
        }
      }
      this.moveLink(event);
    },
    renderPaths() {
      const containerEl = this.$refs.paths;
      containerEl.innerHTML = '';
      this.$refs.nodes.querySelectorAll('.node-connector').forEach(fromEl => {
        const toUuid = fromEl.getAttribute('data-to');
        const toEl = this.$refs.nodes.querySelector(`[data-uuid="${toUuid}"]`);
        if (toUuid && toEl) {
          const rectFrom = UtilEditor.getRectScroll(this.$refs.tempPath, fromEl);
          const rectTo = UtilEditor.getRectScroll(this.$refs.tempPath, toEl);
          UtilEditor.createPathSvg(
            { x: rectFrom.right - 10, y: rectFrom.top + rectFrom.height/2 },
            { x: rectTo.left, y: rectTo.top + rectTo.height/2 },
            containerEl,
            'rgba(255, 168, 0, 0.6)'
          );
        }
      });
      this.dialogTree.forEach(node => {
        if (node.choices) {
          node.choices.forEach(choice => {
            if (choice.to && !this.dialogTree.find(x => x.uuid === choice.to)) {
              choice.to = '';
            }
          });
        }
        if (node.to && !this.dialogTree.find(x => x.uuid === node.to)) {
          node.to = '';
        }
      });
    },
    moveLink(event) {
      if (['mouseup', 'touchend'].includes(event.type)) {
        if (this.linkChoice) {
          let targetEl = event.target;
          if (event.type === 'touchend') {
            const changedTouch = event.changedTouches[0];
            targetEl = document.elementFromPoint(changedTouch.clientX, changedTouch.clientY);
          }
          const selectedEl = targetEl.closest('.node-box');
          let valid = false;
          if (selectedEl) {
            const uuid = selectedEl.getAttribute('data-uuid');
            if (uuid !== this.linkChoice.uuid) {
              valid = true;
              this.linkChoice.choice.to = uuid;
            }
          }
          if (!valid) {
            this.linkChoice.choice.to = null;
          }
        }
        this.linkChoice = null;
        this.$refs.tempPath.innerHTML = '';
      } else if (this.linkChoice) {
        this.$refs.tempPath.innerHTML = '';
        const rect = UtilEditor.getRectScroll(this.$refs.tempPath, this.linkChoice.el);
        const movePosition = Util.eventPosition(event);
        UtilEditor.createPathSvg(
          { x: rect.right - 10, y: rect.top + rect.height/2 },
          movePosition,
          this.$refs.tempPath
        );
      } else if (['mousedown', 'touchstart'].includes(event.type)) {
        const selectedEl = event.target.closest('.node-box');
        const connectorEl = event.target.closest('.node-connector');
        if (selectedEl && connectorEl) {
          const uuid = selectedEl.getAttribute('data-uuid');
          const index = connectorEl.getAttribute('data-index');
          const node = this.dialogTree.find(a => a.uuid === uuid);
          this.linkChoice = {
            choice: index === null ? node : node.choices[index],
            el: connectorEl,
            uuid: uuid
          };
        }
      }
    }
  },
  watch: {
    'fileData.data.edit': {
      handler() {
        const dist = {};
        const nameMap = {};
        this.dialogTree.forEach((node) => {
          nameMap[node.uuid] = node.name || node.uuid;
        });
        this.dialogTree.forEach((node) => {
          const distNode = dist[node.name || node.uuid] = {
            type: node.type || 'dialog'
          };
          switch (distNode.type) {
            case 'split':
              Object.assign(distNode, {
                subtype: node.subtype,
                choices: node.choices.map(choice => {
                  return {
                    condition: choice.condition,
                    weight: choice.weight,
                    to: nameMap[choice.to]
                  };
                })
              });
              break;
            case 'execute':
              Object.assign(distNode, {
                code: node.code,
                to: nameMap[node.to]
              });
              break;
            case 'dialog':
              Object.assign(distNode, {
                text: node.texts,
                asset: node.asset,
                choices: node.choices.map(choice => {
                  return {
                    text: choice.text,
                    next: nameMap[choice.to]
                  };
                })
              });
              break;
          }
          node.attributes.forEach((attribute) => {
            distNode[attribute.key] = attribute.value;
          });
        });
        const initUUID = this.fileData.data.edit.init;
        dist._init = nameMap[initUUID];
        this.fileData.data.dist = dist;
        this.$nextTick(this.renderPaths);
      },
      deep: true
    }
  },
  mounted() {
    this.moveBinded = this.move.bind(this);
    document.addEventListener('mouseup', this.moveBinded, true);
    document.addEventListener('touchend', this.moveBinded, true);
    this.renderPaths();
  },
  beforeUnmount() {
    console.log('Destroy');
    document.removeEventListener('mouseup', this.moveBinded, true);
    document.removeEventListener('touchend', this.moveBinded, true);
  }
}
</script>

<style lang="css" scoped>
.stage {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /* overflow: auto; */
  overflow: hidden;
}
.stage .paths,
.stage .nodes,
.stage .grid {
  position: absolute;
  top: 48px;
  left: 0;
  bottom: 0;
  right: 0;
}
.toolbar {
  position: relative;
  top: 0;
  bottom: auto;
  padding: 5px 20px;
}
.toolbar button {
  margin-right: 10px;
}
.toolbar .submenu {
  display: inline-block;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  padding-left: 10px;
}
.node-box {
  position: absolute;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.1);
  min-width: 40px;
  min-height: 40px;
  background-color: #34434b;
  color: rgba(255, 255, 255, 0.87);
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  width: 250px;
}
.node-box.selected {
  /* box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.8); */
  box-shadow: 0 0 0 3px rgba(255, 168, 0, 0.8);
  z-index: 1;
}
.node-box ::v-deep(*) {
  outline: none;
}
.node-box ::v-deep(label),
.node-box ::v-deep(.label) {
  display: flex;
  font-weight: bold;
  color: #ffa800;
  font-size: small;
  padding: 4px 10px;
  /* background-color: rgba(255, 255, 255, 0.05); */
  background-color: rgba(0, 0, 0, 0.2);
  justify-content: space-between;
  align-items: center;
}
.node-box ::v-deep(label) {
  padding: 10px;
}
.node-box ::v-deep(.btn-icon) {
  color: rgba(255, 255, 255, 0.5);
}
.node-box ::v-deep(.btn-icon:hover) {
  /* color: #000; */
}
.node-box ::v-deep(.label button) {
  margin: 0;
}
.node-box ::v-deep(.icon) {
  font-size: 18px;
}
.node-box .node-header {
  background-color: #265073;
  color: rgba(255, 255, 255, 0.87);
  padding: 0 5px 0 0;
  border-radius: 5px 5px 0 0;
}
.node-box .node-header input {
  border: none;
  font-family: monospace;
  color: inherit;
  font-weight: inherit;
}
.node-box .node-header .btn-icon.selected {
  /* color: #ffa800; */
  color: #fff;
}
.node-box .node-header .btn-icon {
  position: relative;
}
.node-box .node-header .badge {
  font-size: 10px;
  position: absolute;
  bottom: 2px;
  right: 0;
  background-color: #000;
  color: rgba(255, 255, 255, 0.87);
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
}
</style>
